// import React, { useEffect, useState } from "react";
// import { Col, Form, Modal, Row } from "react-bootstrap";
// import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
// import Select from 'react-select';
// import * as HeaderAuthentication from '../../HeaderAuthentication'
// import { loadCompanyDropdownData, postDepartmentDatas } from "../../../redux/action";
// import { useDispatch, useSelector } from "react-redux";
// import { ADDED_BY_ID } from "../../Constants";

// const enablingOptions = [
//     { value: 3, label: "Active" },
//     { value: 4, label: "Inactive" }
// ]

// const AddDepartment = (props) => {
//     let dispatch = useDispatch();
//     const deptData = props.deptData;
//     const singleDepartmentData = props.singleDepartmentData;
//     const deptId = props.deptId;
//     const { getCompanyDropdown } = useSelector((state) => state.data);

//     const [departmentName, setDepartmentName] = useState("");
//     const [selectedOption, setSelectedOption] = useState(null);
//     const [selectedCompany, setSelectedCompany] = useState(null);
//     const [error, setError] = useState("");

//     const handleDepartmentNameChange = (e) => {
//         setDepartmentName(e.target.value);
//         if (e.target.value) {
//             setError(""); // Clear error if input is valid
//         }
//     };

//     const handleSelectChange = (option) => {
//         setSelectedOption(option);
//     };

//     const handleCompanyChange = (option) => {
//         setSelectedCompany(option);
//     };

//     useEffect(() => {
//         dispatch(loadCompanyDropdownData())
//     }, [])

//     useEffect(() => {
//         if (deptId && singleDepartmentData) {
//             setDepartmentName(singleDepartmentData[0]?.DepartmentName);
//             const statusOption = enablingOptions.find(option => option.label === singleDepartmentData[0]?.Status);
//             setSelectedOption(statusOption || null);
//             const companyOption = getCompanyDropdown.find(option => option.value === singleDepartmentData[0]?.CompanyID);
//             setSelectedCompany(companyOption || null);
//         } else {
//             // Reset fields for adding new classification
//             setDepartmentName("");
//             setSelectedOption(null);
//             setSelectedCompany(null);
//         }
//     }, [deptId, singleDepartmentData]);

//     const AddDepartmentData = (e) => {
//         e.preventDefault();
//         if (!departmentName) {
//             setError("Department Name is required.");
//             return;
//         }
//         const data = {
//             CompanyID: selectedCompany?.value || null,
//             DepartmentName: departmentName,
//             DeptID: deptId,
//             StatusID: parseInt(selectedOption?.value),
//             AddedByID: ADDED_BY_ID

//         }
//         let requestOption = {
//             method: "POST",
//             mode: "cors",
//             headers: HeaderAuthentication.postExcomatixAuth,
//             body: JSON.stringify(data),
//         };
//         dispatch(postDepartmentDatas(requestOption, props.handleCloseModal, deptData, deptId));
//     }

//     return (
//         <>
//             <Modal show={props.open} onHide={props.handleCloseModal} className='add-role-modal'>
//                 <Modal.Header closeButton>
//                     <Modal.Title>{deptId ? 'Edit Department' : 'Add Department'}</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <Row className='customer-form-fields'>
//                         <Col>
//                             <Row>
//                                 <Col md={6}>
//                                     <div>
//                                         <label>Company Name</label>
//                                         <Select
//                                             className="react-select-container"
//                                             classNamePrefix="react-select"
//                                             options={getCompanyDropdown}
//                                             placeholder="Select"
//                                             value={selectedCompany}
//                                             onChange={handleCompanyChange}
//                                         />
//                                         {/* {formErrors.CustomFields_CompanyIDFK && <span className="invalid-feedback d-block">{formErrors.CustomFields_CompanyIDFK}</span>} */}
//                                     </div>
//                                 </Col>
//                                 <Col md={6}>
//                                     <div>
//                                         <label>Department Name <span className="required-asterisk">*</span></label>
//                                         <Form.Control
//                                             type="text"
//                                             value={departmentName}
//                                             onChange={handleDepartmentNameChange}
//                                             isInvalid={!!error}
//                                         />
//                                         <Form.Control.Feedback type="invalid">
//                                             {error}
//                                         </Form.Control.Feedback>
//                                     </div>
//                                 </Col>
//                             </Row>
//                             {deptId && <Row>
//                                 <Col md={4}>
//                                     <div>
//                                         <label>Enable / Disable</label>
//                                         <Select
//                                             className="react-select-container"
//                                             classNamePrefix="react-select"
//                                             options={enablingOptions}
//                                             placeholder="Select"
//                                             value={selectedOption}
//                                             onChange={handleSelectChange}
//                                         />
//                                     </div>
//                                 </Col>
//                             </Row>}
//                         </Col>
//                     </Row>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
//                     <SBSaveUpdateBtn btnName="Submit" onClickEffect={AddDepartmentData} />
//                 </Modal.Footer>
//             </Modal>
//         </>
//     );
// }

// export default AddDepartment;




import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import Select from 'react-select';
import * as HeaderAuthentication from '../../HeaderAuthentication';
import { loadCompanyDropdownData, postDepartmentDatas } from "../../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { ADDED_BY_ID } from "../../../Constants";

const enablingOptions = [
    { value: 3, label: "Active" },
    { value: 4, label: "Inactive" }
];

const AddDepartment = (props) => {
    let dispatch = useDispatch();

    // Retrieve sign-in details from sessionStorage
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const SignInCompanyId = signInDetails ? signInDetails[0].CompanyID : null;

    const { getCompanyDropdown } = useSelector((state) => state.data);
    const { deptData, singleDepartmentData, deptId, handleCloseModal } = props;

    const [departmentName, setDepartmentName] = useState("");
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        dispatch(loadCompanyDropdownData());
    }, [dispatch]);

    useEffect(() => {
        if (deptId && singleDepartmentData) {
            setDepartmentName(singleDepartmentData[0]?.DepartmentName || "");
            const statusOption = enablingOptions.find(option => option.label === singleDepartmentData[0]?.Status);
            setSelectedOption(statusOption || null);
            const companyOption = getCompanyDropdown.find(option => option.value === singleDepartmentData[0]?.CompanyID);
            setSelectedCompany(companyOption || null);
        } else {
            setDepartmentName("");
            setSelectedOption(null);
            setSelectedCompany(null);
        }
    }, [deptId, singleDepartmentData, getCompanyDropdown]);

    const validateFields = () => {
        let newErrors = {};
        // if (!selectedCompany) newErrors.company = "Company Name is required.";
        if (!departmentName.trim()) newErrors.department = "Department Name is required.";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const AddDepartmentData = (e) => {
        e.preventDefault();
        if (!validateFields()) return;

        const data = {
            // CompanyID: selectedCompany?.value || null,
            CompanyID: SignInCompanyId,
            DepartmentName: departmentName.trim(),
            DeptID: deptId,
            StatusID: selectedOption ? parseInt(selectedOption.value) : null,
            AddedByID: ADDED_BY_ID
        };

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };

        dispatch(postDepartmentDatas(requestOption, handleCloseModal, deptData, deptId));
    };

    return (
        <Modal show={props.open} onHide={handleCloseModal} className='add-role-modal'>
            <Modal.Header closeButton>
                <Modal.Title>{deptId ? 'Edit Department' : 'Add Department'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className='customer-form-fields'>
                    <Col>
                        <Row>
                            {/* Company Name */}
                            {/* <Col md={6}>
                                <div>
                                    <label>Company Name <span className="required-asterisk">*</span></label>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        options={getCompanyDropdown}
                                        placeholder="Select"
                                        value={selectedCompany}
                                        onChange={(option) => {
                                            setSelectedCompany(option);
                                            setErrors(prev => ({ ...prev, company: "" })); // Clear error
                                        }}
                                    />
                                    {errors.company && <small className="text-danger">{errors.company}</small>}
                                </div>
                            </Col> */}

                            {/* Department Name */}
                            <Col md={12}>
                                <div>
                                    <label className="pb-2 pt-2">Department Name <span className="required-asterisk">*</span></label>
                                    <Form.Control
                                        type="text"
                                        value={departmentName}
                                        onChange={(e) => {
                                            setDepartmentName(e.target.value);
                                            setErrors(prev => ({ ...prev, department: "" })); // Clear error
                                        }}
                                    />
                                    {errors.department && <small className="text-danger">{errors.department}</small>}
                                </div>
                            </Col>
                        </Row>

                        {/* Status Dropdown (Only when Editing) */}
                        {deptId && (
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Enable / Disable</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={enablingOptions}
                                            placeholder="Select"
                                            value={selectedOption}
                                            onChange={(option) => {
                                                setSelectedOption(option);
                                            }}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        )}
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <SbCancelBtn btnName="Cancel" onClickEffect={handleCloseModal} />
                <SBSaveUpdateBtn btnName="Submit" onClickEffect={AddDepartmentData} />
            </Modal.Footer>
        </Modal>
    );
};

export default AddDepartment;
